import cx from 'classnames'
import styles from './NoResultsMessage.module.scss'

const DEFAULT_MESSAGE = 'No results are available'

export const NoResultsMessage = ({ message = DEFAULT_MESSAGE, style }) => (
  <div className={cx('alert', 'alert-info', styles.NoResultsMessage)} style={style}>
    {message}
  </div>
)
